import React from "react"
import Link from "gatsby-link"
import SEO from '../../components/SEO'
import SVGInline from 'react-svg-inline'

import cover from "../../../static/img/servicii/servicii-management-proiect-large.jpg"

class Page extends React.Component {
  render() {
    const pageSEO = {
      title: "Servicii de management de proiect",
      description: "va oferim servicii de management de proiect pentru imobilul dvs.",
      path: "/servicii/management-proiect/"
    };
    return (
      <div className="o-page__content">
        <SEO pageSEO={pageSEO} />
        <div className="c-section-gradient">
          <div className="o-container u-pv-20 u-pv-30@tablet u-text-center@tablet">
            <h1 className="c-page__heading">Servicii de management de proiect</h1>
          </div>
        </div>

        <div className="o-container u-pv-20 u-pv-30@tablet u-bg-white">
          <div className="o-container o-container--text u-ph-0">

            <img className="u-mb-20" src={cover} alt="servicii management de proiect"/>

            <ol className="o-list-10-v">
              <li>Mentinerea legăturii cu proprietarii de apartamente, sau dupa caz cu președintele și comitetul asociației de proprietari.</li>
              <li>Negocierea contractelor cu furnizorii în interesul proprietarilor si colaborarea cu acestia pe parcursul derularii contractului.</li>
              <li>In cazul existentei polițelor de asigurare pe cladire, se va asigura gestionarea acestora. </li>
              <li>Organizarea, supravegherea si controlul lucrarilor de intretinere si imbunatatire a proprietății, conform deciziilor proprietarilor. </li>
              <li>Consultanță privind activitatea de administrare a imobilului.</li>
              <li>Perfectarea si verificarea documentatiei in vederea semnarii contractelor cu furnizorii de servicii.</li>
              <li>Supravegherea derularii optime a contractelor incheiate intre proprietari si furnizorii de servicii.</li>
              <li>Informarea proprietarilor cu privire la actualizarile legilor și reglementărilor legale precum și a hotărârilor emise de Primăria sectorului și de Primăria Municipiului București.</li>
              <li>Respectarea altor obligații stabilite prin contract, in conditiile legii. </li>
              <li>Propunerea bugetului pentru anul urmator in functie de cheltuielile curente pentru anul respectiv si proiectele ce urmeaza a fi dezvoltate.</li>
              <li>Alte sarcini hotărâte prin contractul de administrare.</li>
            </ol>

            <div className="u-text-center">
              <Link to="/preturi/" className="c-button u-mt-30">
                Solicita o oferta personalizata
              </Link>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

export default Page




// WEBPACK FOOTER //
// ./src/pages/servicii/management-proiect.js